module.exports = __webpack_public_path__ + "static/pic09-a86992010d845a4f56ee864a1d5e45dc.jpg";